import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Stack,
  Box
} from "@mui/material";
import { customFieldTypeList } from "common/constants";
import CustomButton from "components/buttons/CustomButton/CustomButton";
import CustomDialog from "components/dialogs/CustomDialog";
import CustomFormSelect from "components/inputs/CustomFormSelect/CustomFormSelect";
import CustomFormTextInput from "components/inputs/CustomFormTextInput/CustomFormTextInput";
import { useState } from "react";
import { useForm, Controller, FormProvider } from "react-hook-form";

const fieldTypeList = customFieldTypeList.map(item => ({
  label: item,
  key: item,
  value: item,
}));

const yesNoList = [
  { key: '1', value: '1', label: 'Yes' },
  { key: '0', value: '0', label: 'No' }
];

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export default function AddCustomFieldModal({ open, onClose, onSubmit }: any) {

  const methods = useForm({
    defaultValues: {
      name: "",
      type: "",
      required: null,
      visible: null,
      value: ""
    }
  });

  const {
    reset,
    handleSubmit,
    register,
    watch,
  } = methods;

  const type = watch('type');

  const submitHandler = (data: any) => {
    const values = {
      ...data,
      visible: data?.visible == '1' ? true : false,
      required: data?.visible == '1' ? true : false,
    }
    onSubmit(values);
    reset();
    onClose();
  };

  return (

    <CustomDialog
      open={open}
      title={'Add Custom Field'}
      alignText='center'
      onClose={onClose}
      content={
        <FormProvider {...methods}>
          <Box
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleSubmit(submitHandler)(e);
            }}
          >

            <Box mt={2}>
              <CustomFormTextInput
                name={'name'}
                register={register}
                floatingLabel='Field title'
                placeholder='Field title'
                required
              />
            </Box>

            <Box mt={2}>
              <CustomFormSelect
                name={'type'}
                options={fieldTypeList}
                floatingLabel='Type'
                placeholder='Select type'
                required
              />
            </Box>

            {type == 'Drop down list' && <Box mt={2}>
              <CustomFormTextInput
                name={'value'}
                register={register}
                floatingLabel='List options'
                placeholder='Option 1, option 2, option 3'
                required
              />
            </Box>}

            <Box mt={2}>
              <CustomFormSelect
                name={'visible'}
                options={yesNoList}
                floatingLabel='Visible'
                placeholder='Select option'
                required
              />
            </Box>

            <Box mt={2}>
              <CustomFormSelect
                name={'required'}
                options={yesNoList}
                floatingLabel='Required'
                placeholder='Select option'
                required
              />
            </Box>


            <Box my={2}>
              <CustomButton
                text={'Add'}
                color='primary'
                fullWidth
                type='submit'
                size='large'
              />
            </Box>

          </Box>
        </FormProvider>
      }
    />
  );
}